<template>
  <div class="container">
    <div class="content" :style="{ backgroundImage: bgColor.bgColor }">
      <div
        class="title-bar"
        :style="{ zIndex: 9, paddingTop: statusBarHeight }"
      >
        <div class="go-back title-box" @click="onGoBack"></div>
        <div class="title-box" style="font-size: 15px">创作等级</div>
        <div
          class="title-box"
          style="font-size: 13px; justify-content: flex-end"
          @click="() => onShowModal(false)"
        >
          等级说明
        </div>
      </div>
      <div ref="wrapper">
        <div class="axis-box" ref="axisBox">
          <div
            class="step"
            v-for="(level, index) in levelList"
            :key="index"
            @click="onClickStep(level)"
            :style="
              index === 0
                ? 'margin-left:3.7rem'
                : index === levelList.length - 1
                ? 'margin-right:3.88rem'
                : ''
            "
          >
            <div
              v-if="level.level === userIndex"
              class="user-dot"
              :style="{ backgroundColor: themeColor }"
            ></div>
            <div class="step-line" :style="getStepStyle(level)"></div>
            <div
              class="step-line last-step-line"
              v-if="index === levelList.length - 1"
            ></div>
            <div class="dot-box" v-if="level.level <= userIndex">
              <div class="dot" :style="{ backgroundColor: themeColor }"></div>
            </div>
            <div class="lock-box" v-else>
              <img src="@/assets/img/creator/lock_new.png" />
            </div>
            <div
              class="text current"
              v-if="level.level === currentLevel"
              :style="{ backgroundColor: themeColor }"
            >
              {{ getLevelText(level) }}
            </div>
            <div class="text" v-else>{{ getLevelText(level) }}</div>
          </div>
        </div>
      </div>
      <Swiper
        class="swiper"
        :options="swiperOptions"
        @transition-end="onChangeSlide"
        @swiper="setControlledSwiper"
      >
        <SwiperSlide v-for="(level, index) in slideLevelOpts" :key="index">
          <div class="swiper-item">
            <div
              class="header"
              :style="{
                backgroundImage: `url(${level.bgUrl})`,
              }"
            >
              <div class="header__content">
                <span
                  class="header__content--top"
                  v-if="userInfo.level === level.level"
                >
                  <img :src="userInfo.icon" />
                  <span>{{ userInfo.nickName }}</span>
                </span>
                <span class="header__content--center"
                  ><span class="level-tit">{{ getLevelText(level) }}</span
                  ><span class="level-des">{{ level.title }}</span>
                </span>

                <p
                  class="header__content--bottom"
                  v-if="userInfo.level === level.level"
                >
                  当前创作分：<span
                    >{{ userInfo.curScore }}<i style="margin: 0 0.05rem">/</i
                    ><i>{{ userInfo.curNeedScore }}</i>
                    <img
                      src="@/assets/img/creator/icon-help.png"
                      @click="onShowModal"
                  /></span>
                </p>
                <p
                  class="header__content--bottom"
                  v-else-if="userInfo.level > level.level"
                >
                  你已超越了该等级<span
                    ><img
                      src="@/assets/img/creator/icon-help.png"
                      @click="onShowModal"
                  /></span>
                </p>
                <p class="header__content--bottom" v-else>
                  未解锁，所需创作分：{{ level.needScore
                  }}<img
                    src="@/assets/img/creator/icon-help.png"
                    @click="onShowModal"
                  />
                </p>
              </div>
              <div
                style="
                  justify-content: right;
                  display: flex;
                  margin-top: 0.48rem;
                "
              >
                <img class="badge-img" :src="level.iconUrl" />
              </div>
            </div>
            <div class="leverl-desc">{{ level.description }}</div>
          </div>
        </SwiperSlide>
      </Swiper>
      <div class="benefit-container">
        <p class="benefit-amount">
          <span class="line"></span>
          {{ currentLevel === userInfo.level ? '您当前' : '该等级' }}可享受<span
            class="amount"
            >{{ benefitAmount }}</span
          >项权益<span class="line"></span>
        </p>
        <div class="benefit-box">
          <div
            v-for="(benefit, index) in benefitList"
            :key="index"
            class="benefit-item"
            @click="() => onShowbenefitDetail(benefit)"
            :style="getBenefitStyle(benefit)"
          >
            <img :src="benefit.iconUrl" class="benefit-icon" />
            <span>{{ benefit.name }}</span>
          </div>
          <i></i><i></i><i></i><i></i>
        </div>
      </div>
    </div>

    <Modal :onClose="() => (showModal = false)" :showModal="showModal">
      <div v-if="showLevelIntro">
        <LevelIntro :data="levelList[currentLevel]" />
      </div>
      <PointsIntro :data="pointsDesc" />
      <div @click="toDetailRule" class="detail-btn">查看完整等级规则说明</div>
    </Modal>
    <Modal
      :onClose="() => (showBenefitModal = false)"
      :showModal="showBenefitModal"
      :boxStyle="isSatisfied ? {} : { height: '5.6rem' }"
    >
      <BenefitIntro :data="activeBenefit" :isSatisfied="isSatisfied" />
    </Modal>
    <Modal
      :onClose="() => (showUpdateModal = false)"
      :showModal="showUpdateModal"
      :boxStyle="{
        margin: '0 0.16rem',
        height: '5.8rem',
        bottom: bottomSpace + 8 + 'px',
        'border-radius': '0.56rem',
        paddingTop: '0.48rem',
      }"
      :showBottomMask="false"
      :greyIcon="true"
    >
      <div class="update-box">
        <p class="update-title">
          {{ updateText }}
        </p>
        <p class="update-desc">{{ updateDesc }}</p>
        <img :src="updateImgUrl" class="badge-img-shadow" />
        <div class="update-btn" @click="closeUpdateModal">我知道了</div>
      </div>
    </Modal>
  </div>
</template>
<script>
import PointsIntro from '@/components/creator/PointsIntro.vue'
import Modal from '@/components/creator/Modal.vue'
import BenefitIntro from '@/components/creator/BenefitIntro.vue'
import LevelIntro from '@/components/creator/LevelIntro.vue'
import open from '@ky/sdk/dist/open'
import getBottomSpace from '@ky/sdk/dist/getBottomSpace'
import getStatusBarHeight from '@ky/sdk/dist/getStatusBarHeight'
import callNative from '@ky/sdk/dist/callNative'
import canUseBridge from '@ky/sdk/dist/canUseBridge'
import isInKwaiying from '@ky/sdk/dist/isInKwaiying'
import isIphone from '@ky/sdk/dist/isIphone'
import isPad from '@ky/sdk/dist/isPad'
import openNativePage from '@ky/sdk/dist/open'
import setPageBounce from '@ky/sdk/dist/setPageBounce'
import BScroll from '@better-scroll/core'
import request from '@ky/sdk/dist/request'
import { addListener, invoke } from '@yoda/bridge'
import getCookie from '@ky/sdk/dist/getCookies'
import weblog from '@ky/sdk/dist/log/kylogger'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import '@/assets/css/lib/swiper.min.css'
import '@/public/js/flexible.js'
const detailRuleUrl =
  'kwaiying://web?url=https%3A%2F%2Fdocs.qq.com%2Fdoc%2FDVEV4ZVJYWk1wUVph&showTopBar=true'

export default {
  name: 'new-rating',
  components: { PointsIntro, Modal, BenefitIntro, LevelIntro },
  data() {
    return {
      userInfo: { nickName: '', level: 1 },
      currentLevel: 0,
      themeColor: '#BCBCBC',
      bgColor: { rgbaColor: '', bgColor: '' },
      levelList: [
        {
          resourceId: 1407084,
          level: 0,
          title: '小白模板师',
          description:
            '提供模板被使用情况、数据趋势、模板详情等维度，助力更好了解创作效果。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/a5c58bbf14b587c2ce9f2be5f78efc2f2fba929d.png',
          needScore: 0,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/fa92965c70fde0d14b82420463bae7a385eec8ea.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/477bf6c8218ed6a6f661a174cba2377438e3c1c2.png',
          themeColor: '#76B1E8',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, rgba(118, 177, 232, 0.7) 0%, rgba(118, 177, 232, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #202F41 0%, #141414 65.69%)',
          },
        },
        {
          resourceId: 1407085,
          level: 1,
          title: '新生模板师',
          description:
            '模板上线后，达到制作规范后，有机会享受初始的曝光流量或官方推荐。获取「微光模板师」专属身份认证，并在个人页的昵称下方对外展示。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/dfcb55829a7d9e3b4b7e1e13b93ac64f13540e51.png',
          needScore: 10,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/f58249ad3b0a7e0f5e619639fccf1174d0d920e8.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/477bf6c8218ed6a6f661a174cba2377438e3c1c2.png',
          themeColor: '#76B1E8',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, rgba(118, 177, 232, 0.7) 0%, rgba(118, 177, 232, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #202F41 0%, #141414 65.69%)',
          },
        },
        {
          resourceId: 1407086,
          level: 2,
          title: '实习模板师',
          description:
            '新发布的模板达到基础有效导出量后，即可参与官方每周的现金奖励池的瓜分。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/fff1998e63b01acabc9d443f1360096dc4f9fb7e.png',
          needScore: 200,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/c0b03ad40f7e62d4c6409061951173f0edf131c1.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/477bf6c8218ed6a6f661a174cba2377438e3c1c2.png',
          themeColor: '#76B1E8',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, rgba(118, 177, 232, 0.7) 0%, rgba(118, 177, 232, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #202F41 0%, #141414 65.69%)',
          },
        },
        {
          resourceId: 1407087,
          level: 3,
          title: '初阶模板师',
          description:
            '你当下还可以享受新星激励，持续冲刺升级可享受模板快审权益',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/f375caf3bbdabb8303861e614565b5ff8266238c.png',
          needScore: 400,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/ad27c89d410aeaef004eeab85a5c0a5b97d1a1e9.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/a30d29a724cfe0a138a2fc4cc02e5da549e4b1b1.png',
          themeColor: '#8D80EA',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, #8D80EA 4.1%, rgba(141, 128, 234, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #2D2A40 0%, #141414 68.3%)',
          },
        },
        {
          resourceId: 1407088,
          level: 4,
          title: '中阶模板师',
          description: '新发布的模板可进入快速审核通道，助力模板快速上线。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/b8ed25d012007a6757308ef36ae6afd3f0397eae.png',
          needScore: 1000,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/5d66021afd7a30778b4a9029a9aac88a8f6750e9.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/a30d29a724cfe0a138a2fc4cc02e5da549e4b1b1.png',
          themeColor: '#8D80EA',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, #8D80EA 4.1%, rgba(141, 128, 234, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #2D2A40 0%, #141414 68.3%)',
          },
        },
        {
          resourceId: 1407089,
          level: 5,
          title: '进阶模板师',
          description:
            '新发布的模板达到优质和数据要求后，官方予以发放现金奖励，单个模板最高达12000元。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/142e7fc1c3f310c8e3af761ef2bddb4d68b0a5ca.png',
          needScore: 3500,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/a01caf9661704799d57e8978f8c268559fe80f07.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/a30d29a724cfe0a138a2fc4cc02e5da549e4b1b1.png',
          themeColor: '#8D80EA',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, #8D80EA 4.1%, rgba(141, 128, 234, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #2D2A40 0%, #141414 68.3%)',
          },
        },
        {
          resourceId: 1407090,
          level: 6,
          title: '专业模板师',
          description:
            '你当下还可以享受平台激励，持续冲刺升级可拥有与精选品牌合作的机会',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/c1d97c82f3204b71ecb69d8aef95b14f69f0fc62.png',
          needScore: 8000,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/8dfdac463f820f074c9102913cd8cff4fd4cc369.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/265ac462fee4cc58e2d8720433cd755efb1e020f.png',
          themeColor: '#E84566',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, #E84566 4.1%, rgba(232, 69, 102, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #4B2A30 -19.61%, #141414 62.75%)',
          },
        },
        {
          resourceId: 1407091,
          level: 7,
          title: '优质模板师',
          description:
            '拥有与精选品牌合作的机会，完成品牌需求上线模板，即可获得商业收入，增加模板变现能力。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/feaf9860f367714accc1bd3860b4e354df97a1c9.png',
          needScore: 15000,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/c4f6284600f86b5d0191bb037474c5bcee086352.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/265ac462fee4cc58e2d8720433cd755efb1e020f.png',
          themeColor: '#E84566',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, #E84566 4.1%, rgba(232, 69, 102, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #4B2A30 -19.61%, #141414 62.75%)',
          },
        },
        {
          resourceId: 1407092,
          level: 8,
          title: '杰出模板师',
          description:
            '拥有与快影官方合作的机会，享受专属模板流量扶持、商单优先权等权益',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/8efa55fd397294469c4093295a590948cb863f26.png',
          needScore: 30000,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/7dfbb437c7875d935528923d9ac6b0497bfb2b75.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/265ac462fee4cc58e2d8720433cd755efb1e020f.png',
          themeColor: '#E84566',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, #E84566 4.1%, rgba(232, 69, 102, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #4B2A30 -19.61%, #141414 62.75%)',
          },
        },
        {
          resourceId: 1407093,
          level: 9,
          title: '创作大神',
          description:
            '有机会受邀参与品牌活动，与快影、快手、明星、企业等共建个人影响力。',
          iconUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/6763a963b5beecc16a8a5bd8ca0cdae941a34d93.png',
          needScore: 50000,
          iconUrlWithShadow:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/6122c37db0a8514403d78a4a1d56bdd899dde27f.png',
          bgUrl:
            'https://p4-ky.wsukwai.com/udata/pkg/admin-center/89cba8921c01732c7462bb4cef5af0c2abda5811.png',
          themeColor: '#F3B88D',
          bgColor: {
            rgbaColor:
              'linear-gradient(270deg, rgba(243, 177, 141, 0.7) 0%, rgba(243, 177, 141, 0) 100%)',
            bgColor: 'linear-gradient(180deg, #42332B 0%, #141414 61.44%)',
          },
        },
      ],
      screenWidth: 0,
      showModal: false,
      showBenefitModal: false,
      showUpdateModal: false,
      showLevelIntro: true,
      benefitList: [],
      activeBenefit: {},
      pointsDesc: {
        title: '什么是创作分',
        description: `创作分是按快影模板师模板的历史累计数据计算，课程、素材创作暂不纳入，共分为10级，达到最低分数即可升级和解锁对应权益`,
        structure: [
          {
            name: '模板发布分',
            intro:
              '每天发布首个模板加10分，第2个模板加2分，之后每个模板1分，单日15分封顶',
          },
          {
            name: '模板优质分',
            intro: '当你的模板被官方被评定为优质后，所能获得的分数，上不封顶',
          },
          {
            name: '模板导出用户分',
            intro: '模板成功上线后，按模板累计导出成功用户数据综合计算所得',
          },
          {
            name: '模板拉新拉活分',
            intro:
              '快手用户在浏览视频作品时，通过你的模板的剪同款链接跳转回快影的用户数，综合计算所得',
          },
          {
            name: '快手粉丝分',
            intro: '快影绑定的对应快手号粉丝数据综合计算所得',
          },
          {
            name: '其他',
            intro: '目前暂无，具体请留意平台相关通知',
          },
        ],
      },
      updateText: '当前等级',
      updateDesc: '快来看看该等级享有什么权益',
      updateImgUrl: '',
      swiper: {},
    }
  },
  computed: {
    userIndex() {
      return this.levelList.findIndex(
        (item) => item.level === this.userInfo.level
      )
    },
    currentIndex() {
      return this.levelList.findIndex(
        (item) => item.level === this.currentLevel
      )
    },
    slideLevelOpts() {
      return this.levelList.filter((item) => item !== 'LOCK')
    },
    swiperOptions() {
      const w = Math.round(0.835 * this.screenWidth)
      const gap = 12
      const offset = (this.screenWidth - w) / 2
      return {
        initialSlide: 0,
        centeredSlides: true,
        slidesPerView: 'auto',
        spaceBetween: gap,
        slidesOffsetBefore: offset,
        slidesOffsetAfter: offset,
        width: w,
        onTransitionEnd: this.onChangeSlide,
      }
    },
    benefitAmount() {
      return this.benefitList.filter(
        (item) => this.currentLevel >= item.minLevel
      ).length
    },
    isSatisfied() {
      return this.userInfo.level >= this.activeBenefit.minLevel
    },
  },
  watch: {
    showModal(val) {
      document.body.style = `overflow: ${val ? 'hidden' : 'auto'};`
    },
    showBenefitModal(val) {
      document.body.style = `overflow: ${val ? 'hidden' : 'auto'};`
    },
    showUpdateModal(val) {
      document.body.style = `overflow: ${val ? 'hidden' : 'auto'};`
    },
    currentIndex(val) {
      this.themeColor = this.levelList[val].themeColor
      this.bgColor = this.levelList[val].bgColor
    },
  },
  methods: {
    onGoBack() {
      if (this.$route.query.backJumpUrl) {
        openNativePage(this.$route.query.backJumpUrl)
      } else {
        window.kwaiying && window.kwaiying.goBack()
      }
    },
    async getRankPageData() {
      try {
        const isPro = process.env.NODE_ENV === 'production'
        const host = isPro
          ? 'http://pg.kmovie-api.internal'
          : 'https://kmovie-liqiao-prod-prt.test.gifshow.com'
        const query = {}
        query.userId = await getCookie('userId')
        query.did = await getCookie('did')
        query.passToken = await getCookie('passToken')
        query.apiSt = await getCookie('ky.api_st')
        console.log('=query==', query)
        const data = await $fetch('/api/proxy', {
          method: 'POST',
          body: {
            url: `${host}/rest/n/kmovie/app/user/info/getUserLevelInfo?isTest=${
              isPro ? 0 : 1
            }`,
            ...query,
          },
        })
        console.log('==data=', data)
        // const data = await request.get(
        //   `${host}/rest/n/kmovie/app/user/info/getUserLevelInfo?isTest=${
        //     isPro ? 0 : 1
        //   }`
        // )
        this.webLog.sendImmediately('PV', {
          type: 'enter',
          page: 'CREATE_LEVEL_DETAIL',
          params: {
            grade: data?.userInfo?.level + '',
            msg_id: this.$route.query.msgId,
            msgTraceTag: this.$route.query.msgTraceTag,
          },
        })
        if (data.result === 1) {
          this.userInfo = data.userInfo || {}
          this.currentLevel = data.userInfo.level || 0
          this.themeColor = data.config[this.currentLevel].themeColor
          this.bgColor = data.config[this.currentLevel].bgColor
          this.levelList = data.config
          this.benefitList = data.benefit
          // window.scrollTo({ top: 0, behavior: 'smooth' });
          if (this.popup_type) {
            this.webLog.sendImmediately('SHOW', {
              action: 'CREATE_LEVEL_POPUP',
              params: {
                from: this.from,
                popup_type: this.popup_type,
              },
              urlPage: {
                page: 'CREATE_LEVEL_DETAIL',
              },
            })
            this.showUpdateModal = true
            if (this.popup_type === 'change_remind') {
              this.updateText = '您的创作等级为 K' + data.userInfo.level
              this.updateDesc = '快来看看该等级享有什么权益'
            }
            if (this.popup_type === 'upgrade_remind') {
              this.updateText = '恭喜你升级了'
              this.updateDesc = `创作等级从 K${
                data.userInfo.level - 1
              } 升级到 K${data.userInfo.level} 了，来看看专属权益吧`
            }
          }

          this.updateImgUrl =
            this.levelList[data.userInfo.level].iconUrlWithShadow
          this.swiper.slideTo(data.userInfo.level)
        }
      } catch (e) {}
    },
    getStepStyle(level) {
      const index = level.level
      return {
        width: index === 0 ? '3.8rem' : '1.54rem',
        background:
          // eslint-disable-next-line no-nested-ternary
          index <= this.userIndex
            ? index === 0
              ? this.bgColor.rgbaColor
              : this.themeColor
            : 'rgba(255, 255, 255, 0.08)',
      }
    },
    getDotStyle(level) {
      const index = level.level
      return {
        backgroundColor: index <= this.userIndex ? this.themeColor : '#000',
      }
    },
    getLevelText(level) {
      return `K${level.level}`
    },
    onClickStep(level) {
      this.currentLevel = level.level
      this.swiper.slideTo(this.currentIndex)
    },
    onChangeSlide(swiper) {
      console.log('=onChangeSlide===')
      this.currentLevel = swiper.activeIndex
      const width = Math.min(document.documentElement.clientWidth, 750)
      const space = 1.54 * (width / 7.5)
      if (this.scroll) {
        this.scroll.scrollTo(-this.currentIndex * space, 0, 200)
      }
      this.webLog.sendImmediately('CLICK', {
        action: 'LEVEL_SWITCH',
        params: {
          click_grade: this.currentLevel + '',
          grade: this.userInfo.level + '',
        },
        urlPage: {
          page: 'CREATE_LEVEL_DETAIL',
        },
      })
    },
    onShowModal(showLevelIntro = true) {
      if (showLevelIntro) {
        this.showModal = true
      } else {
        open(detailRuleUrl, { showTopBar: true })
      }
      this.webLog.sendImmediately('CLICK', {
        action: 'CHRCK_RULES',
        params: {
          click_position: showLevelIntro ? '创作分问号' : '右上角等级说明',
        },
        urlPage: {
          page: 'CREATE_LEVEL_DETAIL',
        },
      })
    },
    onShowbenefitDetail(item) {
      this.activeBenefit = item
      if (item.detailRule[0].type === 3 && this.isSatisfied) {
        open(item.detailRule[0].body[0].text)
      } else {
        this.showBenefitModal = true
      }
      this.webLog.sendImmediately('CLICK', {
        action: 'CHECK_RIGHTS',
        urlPage: {
          page: 'CREATE_LEVEL_DETAIL',
        },
      })
    },
    getBenefitStyle(benefit) {
      if (benefit.minLevel > this.currentLevel)
        return {
          opacity: 0.5,
        }
      return { opacity: 1 }
    },
    closeUpdateModal() {
      this.showUpdateModal = false
      this.webLog.sendImmediately('CLICK', {
        action: 'CREATE_LEVEL_POPUP',
        params: {
          from: this.from,
          popup_type: this.popup_type,
        },
        urlPage: {
          page: 'CREATE_LEVEL_DETAIL',
        },
      })
    },
    toDetailRule() {
      open(detailRuleUrl, { showTopBar: true })
    },
    async initBackBehavior() {
      if (
        this.$route.query.backJumpUrl &&
        isInKwaiying() &&
        !isIphone() &&
        !isPad()
      ) {
        try {
          await invoke('ui.setPhysicalBackButtonBehavior', { behavior: 'none' })
          await invoke(
            'ui.setSlideBackBehavior',
            {
              behavior: 'default',
            },
            {}
          )
          addListener('physical-back-button', (res) => {
            if (res.behavior === 'none') {
              this.onGoBack()
            }
          })
        } catch (error) {
          console.log('error ', error)
        }
      }
    },
    setControlledSwiper(swiper) {
      this.swiper = swiper
    },
  },
  async created() {
    const nuxtApp = useNuxtApp()
    if (process.client) {
      const vueApp = nuxtApp.vueApp
      vueApp.use(VueAwesomeSwiper)
    }
    this.screenWidth = document.documentElement.clientWidth
    const { from, popup_type } = this.$route.query
    this.popup_type = popup_type
    this.from = from
    this.bottomSpace = getBottomSpace()
    this.statusBarHeight = (getStatusBarHeight() || 40) + 'px'
    this.webLog = weblog
    if (isInKwaiying()) {
      callNative('updateCookie', { isPromise: false })
      setTimeout(() => {
        this.getRankPageData()
      }, 100)
    }
  },
  async mounted() {
    this.$nextTick(() => {
      if (!this.scroll) {
        this.scroll = new BScroll(this.$refs.wrapper, {
          scrollX: true,
          scrollY: false,
          eventPassthrough: 'vertical',
          bounce: false,
        })
      } else {
        this.scroll.refresh()
      }
      setTimeout(() => {
        if (canUseBridge('tryShowFreeToPayDialog'))
          callNative('tryShowFreeToPayDialog', {
            isPromise: false,
            params: {
              scene: 'profileTemplateData',
            },
            timeout: 0,
          })
      }, 500)
    })
    const width = Math.min(document.documentElement.clientWidth, 750)
    const rem = width / 7.5
    this.$refs.axisBox.style.width =
      1.54 * 9 * rem + document.documentElement.clientWidth + 'px'
    this.initBackBehavior()
  },
}
</script>
<style lang="less" scoped>
@font-family-default: PingFangSC-Regular;
@font-family-medium: PingFangSC-Medium;
@font-family-bold: PingFangSC-Semibold;
*,
:after,
:before {
  box-sizing: content-box;
  margin: 0;
}
.container {
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-size: 100% 8rem;
  background-repeat: no-repeat;
  color: rgba(255, 255, 255, 1);
  overflow-x: hidden;
  background-color: #141414;
  img {
    display: block;
  }
  .content {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
    background-size: 100% 6.12rem;
    background-repeat: no-repeat;
    .title-bar {
      position: relative;
      top: 0;
      height: 0.88rem;
      line-height: 0.88rem;
      z-index: 9;
      color: rgba(255, 255, 255, 0.9);
      align-items: center;
      display: flex;
      //background-color: #d62a2d;
      justify-content: space-between;
      padding: 0 16px;
      .go-back {
        background-image: url('@/assets/img/creator/back.png');
        background-repeat: no-repeat;
        background-size: 0.48rem 0.48rem;
        background-position: left;
      }
      .title-box {
        width: 1.5rem;
        height: 0.85rem;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .axis-box {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 0.1rem;
      padding-top: 0.1rem;
      // width: 100%;
      // overflow-x: scroll;
      // overflow-y: hidden;
      .axis {
        position: absolute;
        width: 10rem;
        height: 0.05rem;
        background-color: #000;
        left: 0.76rem;
        top: 0.06rem;
      }
      .axis__highlight {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        background-color: rgba(247, 54, 93, 1);
      }

      .axis-mask {
        position: absolute;
        top: 0;
        width: 41.9%;
        height: 0.44rem;
        pointer-events: none;
        &.left {
          left: 0;
          background: linear-gradient(
            270deg,
            rgba(25, 25, 25, 0),
            rgba(25, 25, 25, 0.3) 39%,
            rgba(25, 25, 25, 0.6)
          );
        }
        &.right {
          right: 0;
          background: linear-gradient(
            90deg,
            rgba(25, 25, 25, 0),
            rgba(25, 25, 25, 0.3) 39%,
            rgba(25, 25, 25, 0.6)
          );
        }
      }
      .step {
        // position: absolute;
        // top: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        // transform: translateX(-50%);
        width: 0.12rem;
        height: 1rem;
        margin: 0 0.71rem;
        position: relative;
      }
      .user-dot {
        position: absolute;
        width: 0.16rem;
        height: 0.16rem;
        background-color: #bcbcbc;
        border-radius: 50%;
        z-index: 10;
      }
      .step-line {
        display: inline-block;
        position: absolute;
        top: 0.06rem;
        right: 0;
        background-color: rgba(255, 255, 255, 0.7);
        width: 1.54rem;
        height: 0.05rem;
      }
      .last-step-line {
        width: 3.88rem;
        left: 0.16rem;
        background-color: rgba(255, 255, 255, 0.08);
      }
      .dot-box {
        display: flex;
        height: 0.22rem;
      }
      .lock-box {
        height: 0.22rem;
        img {
          width: 0.16rem;
          height: 0.22rem;
          position: absolute;
          top: -0.05rem;
          z-index: 10;
          left: -0.02rem;
        }
      }
      .dot {
        position: relative;
        width: 0.12rem;
        height: 0.12rem;
        border-radius: 50%;

        margin-top: 0.03rem;
      }
      .text {
        margin-top: 0.1rem;
        font-family: @font-family-medium;
        font-size: 0.2rem;
        color: rgba(255, 255, 255, 0.4);
        white-space: nowrap;
        height: 0.28rem;
        line-height: 0.29rem;
        padding: 0 0.12rem;
        border-radius: 0.14rem;
        background-color: rgba(0, 0, 0, 0);
        &.current {
          color: #222;
          padding: 0 0.12rem;
          border-radius: 0.14rem;
        }
      }
    }
    .axis-box::-webkit-scrollbar {
      width: 0 !important;
    }
    .swiper {
      .swiper-slide {
        width: 6.46rem;
        //height: 3.18rem;
        // https://github.com/nolimits4web/swiper/issues/3527
        -webkit-transform: translate3d(0, 0, 0);
      }
      .swiper-item {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 0.17rem;
        .header {
          display: flex;
          padding: 0 0.4rem 0 0.4rem;
          color: rgba(255, 255, 255, 0.9);
          font-size: 0.3rem;
          width: 6.46rem;
          height: 3.18rem;
          box-sizing: border-box;
          background: rgba(255, 255, 255, 0.06);
          border-radius: 12px;
          background-size: 100% 100%;
          object-fit: contain;
          background-position: center;
          justify-content: space-between;
          .header__content {
            margin-top: 1.04rem;
          }
          .header__content--top {
            display: flex;
            align-items: center;
            font-family: @font-family-medium;
            font-size: 0.22rem;
            line-height: 0.25rem;
            color: rgba(255, 255, 255, 0.9);
            flex-direction: row;
            position: absolute;
            top: 0.5rem;
            img {
              width: 0.32rem;
              height: 0.32rem;
              border-radius: 50%;
              border: 0.8px solid rgba(255, 255, 255, 0.7);
              margin-right: 0.12rem;
            }
            span {
              text-overflow: ellipsis;
              overflow: hidden;
              white-space: nowrap;
              width: 2.5rem;
            }
          }
          .header__content--center {
            display: flex;
            margin-bottom: 0.2rem;
            font-size: 0.42rem;
            font-family: 'PingFang SC';
            line-height: 0.62rem;
            font-weight: 600;

            opacity: 0.9;
            .level-tit {
              font-family: 'Avenir Next';
              font-style: italic;
              font-weight: 700;
              font-size: 0.52rem;
              min-width: 0.8rem;
              display: inline-block;
              padding: 0.02rem 0;
              background: linear-gradient(
                180deg,
                #ffffff 0%,
                rgba(255, 255, 255, 0.8) 87.8%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
            }
            .level-des {
              background: linear-gradient(
                180deg,
                #ffffff 0%,
                rgba(255, 255, 255, 0.8) 87.8%
              );
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              background-clip: text;
              text-fill-color: transparent;
            }
          }
          .header__content--bottom {
            font-size: 0.22rem;
            line-height: 0.3rem;
            color: rgba(255, 255, 255, 0.5);
            display: flex;
            flex-direction: row;
            justify-content: start;
            align-items: center;
            flex-wrap: wrap;
            span {
              color: rgba(255, 255, 255, 0.9);
              display: flex;
              align-items: center;
            }
            img {
              margin-left: 0.08rem;
              width: 0.24rem;
              height: 0.24rem;
              margin-bottom: 0.02rem;
            }
            i {
              color: rgba(255, 255, 255, 0.5);
            }
          }
        }
        .leverl-desc {
          color: rgba(255, 255, 255, 0.5);
          font-size: 0.22rem;
          line-height: 0.3rem;
          padding: 0.28rem;
          padding-bottom: 0;
        }
      }
    }
  }
  .badge-img {
    flex-shrink: 0;
    width: 2.24rem;
    height: 2.24rem;
    object-fit: contain;
  }
  .badge-img-shadow {
    flex-shrink: 0;
    width: 2.94rem;
    height: 2.62rem;
    object-fit: contain;
  }
  .benefit-amount {
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.24rem;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.32rem 0;
    position: relative;
    margin: 0 0.32rem;
    border-bottom: 0.01rem solid rgba(255, 255, 255, 0.06);
    .line {
      display: inline-block;
      width: 0.16rem;
      height: 0.01rem;
      background-color: rgba(255, 255, 255, 0.2);
      margin: 0 0.26rem;
    }
    .amount {
      font-family: 'DIN Alternate';
      font-weight: 700;
      font-size: 0.3rem;
      line-height: 0.4rem;
      color: rgba(255, 255, 255, 0.9);
      margin: 0 0.08rem;
      margin-bottom: 0.02rem;
    }
  }
  .benefit-container {
    background: rgba(255, 255, 255, 0.04);
    border-radius: 0.24rem 0.24rem 0 0;
    flex: 1;
    margin: 0.32rem 0.32rem 0 0.32rem;
  }
  .benefit-box {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    padding: 0.48rem;
    font-size: 0.22rem;
    color: rgba(255, 255, 255, 0.9);
    .benefit-item {
      width: 1.24rem;
      height: 1.36rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.48rem;
    }
    .benefit-icon {
      width: 0.48rem;
      height: 0.48rem;
      margin-bottom: 0.14rem;
    }
    i {
      width: 1.24rem;
    }
  }
  .update-box {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .update-title {
    font-weight: 500;
    font-size: 0.3rem;
    line-height: 0.46rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.9);
  }
  .update-desc {
    font-size: 0.26rem;
    line-height: 0.4rem;
    text-align: center;
    color: rgba(255, 255, 255, 0.4);
    margin: 0.16rem 0;
  }
  .update-btn {
    background: linear-gradient(
      135deg,
      #f52c6f 0%,
      #f7365d 49.58%,
      #ff5151 100%
    );
    border-radius: 0.52rem;
    width: 3.16rem;
    height: 0.88rem;
    font-weight: 500;
    font-size: 0.3rem;
    line-height: 0.88rem;
    color: rgba(255, 255, 255, 0.9);
    text-align: center;
    margin-top: 0.48rem;
  }
  .detail-btn {
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 0.52rem;
    padding: 0.34rem 1.144rem;
    text-align: center;
    margin: 0.4rem 0.8rem;
    width: 5.28rem;
    height: 1.04rem;
    padding: 0.34rem 0;
    font-size: medium;
  }
}
</style>
